import { useState } from 'react';
import PermissionWrapper from '../context/PermissionWrapper';

export default function BulkInvoiceButton({ axiosInstance, onResult }) {
  const [loading, setLoading] = useState(false);
  const handleBulkInvoice = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.post('api/financial/bulk-invoice/');
      if (response.data && onResult) {
        onResult(response.data);
      }
    } catch (error) {
      if (onResult) {
        onResult({ message: 'Error al generar facturas faltantes.' });
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <PermissionWrapper feature="financiero_payables_own" action="delete">
      <button
        className="btn btn-warning"
        style={{ marginBottom: '1rem' }}
        onClick={handleBulkInvoice}
        disabled={loading}
      >
        {loading ? 'Procesando...' : 'Generar facturas faltantes'}
      </button>
    </PermissionWrapper>
  );
}
